import React from "react";
import { GridRow, GridColumn, GridHeaders, GridHeader, GridContainer } from "./styles";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons";

export type RangeDateType = {
  id: string;
  startDate: string | null;
  endDate: string | null;
  weekDays: string[];
};

type RangeDateGridProps = {
  list?: RangeDateType[];
  headers?: string[];
  editable?: boolean;
  deletable?: boolean;
  onEdit?: (id: string) => void;
  onDelete?: (id: string) => void;
};

export const RangeDateGrid = ({
  list,
  headers,
  editable = false,
  deletable = false,
  onEdit,
  onDelete,
}: RangeDateGridProps) => {
  return (
    <GridContainer>
      <GridHeaders>
        {headers?.map(header => (
          <GridHeader>{header}</GridHeader>
        ))}
      </GridHeaders>
      {list?.map((row: RangeDateType) => (
        <GridRow>
          <GridColumn>{row.startDate}</GridColumn>
          <GridColumn>{row.endDate}</GridColumn>
          <GridColumn>{row.weekDays?.join(",")}</GridColumn>
          {editable && onEdit && (
            <Button
              data-tip="React-tooltip"
              data-for="editLevel"
              size="sm"
              variant="light"
              onClick={() => onEdit(row.id)}>
              <FontAwesomeIcon icon={faPencilAlt} />
            </Button>
          )}
          {deletable && onDelete && (
            <Button
              size="sm"
              variant="light"
              onClick={() => onDelete(row.id)}
              data-tip="React-tooltip"
              data-for="delete">
              <FontAwesomeIcon icon={faTrashAlt} />
            </Button>
          )}
        </GridRow>
      ))}
    </GridContainer>
  );
};
